// v33 — level-up oslava ako samostatný detail-modal (nie banner): otvára sa AŽ o pár sekúnd po
// dosiahnutí levelu (nech neprekryje čerstvú radosť z rozprsknutého návyku), farebne CELÁ podľa
// dosiahnutého tieru — hlavička aj telo. Rovnaký zdroj sa otvára aj zo zvončeka (tapnutie na
// notifikáciu "levelup"), takže level-up je vidno aj neskôr, nielen na Dnes.
import { BuzerIcon } from "../../BuzerIcons";
import { LEVEL_ICON, TIER_ICON } from "../../LevelIcons";
import { LEVELS, LEVEL_CATS, gname } from "../../lib/levels";
import { Button } from "./ds";
import { Modal } from "./Modal";
import { TIER_RINGS, tierCardStyle } from "./Avatar";

// Pevná blahoželacia veta (predtým striedaný set — zjednotené na jednu, presne zadanú formuláciu).
const CONGRATS = "Nový level odomknutý. Každý ďalší level je dôkaz, že to myslíš vážne.";

export function LevelUpModal({ idx, onClose }) {
  const lvl = LEVELS[Math.max(1, Math.min(idx || 1, LEVELS.length)) - 1];
  if (!lvl) return null;
  const tier = Math.max(0, Math.min(lvl.cat, TIER_RINGS.length - 1));
  const tierName = (LEVEL_CATS[tier] || {}).name || "";
  const iconName = LEVEL_ICON[idx] || TIER_ICON[tierName] || "star2";
  // v33h — prefarbenie karty podľa tieru je teraz zdieľané (Avatar.tierCardStyle): ten istý štýl
  // používa aj verejný profil (ProfileBody/ProfileModal), takže level-up a profil vyzerajú rovnako.
  const cardStyle = tierCardStyle(lvl.cat);
  /* token-exempt-start: obsah modalu leží na farebnej karte tieru — biele priehľadné vrstvy
     (chip/watermark/text) nad ňou, nezávislé od témy (rovnaká výnimka ako predtým). */
  return (
    <Modal center title="Nový level!" icon={iconName} subtitle={`Lv ${idx}`} maxWidth={400}
      onClose={onClose} cardStyle={cardStyle} tourAttr={{ "data-tour": "levelup" }}>
      <div style={{ position: "relative", textAlign: "center", padding: "4px 2px 2px", overflow: "hidden" }}>
        {/* veľká priesvitná ikona levelu na pozadí — rovnaký prístup ako watermark v ProfileBody */}
        <span aria-hidden style={{ position: "absolute", top: -30, right: -26, transform: "rotate(-10deg)", opacity: 0.15, pointerEvents: "none" }}>
          <BuzerIcon name={iconName} size={180} color="#fff" />
        </span>
        <span style={{ position: "relative", display: "inline-flex", alignItems: "center", justifyContent: "center",
          width: 86, height: 86, borderRadius: "50%", background: "rgba(255,255,255,.18)",
          border: "1px solid rgba(255,255,255,.32)", margin: "8px auto 20px" }}>
          <BuzerIcon name={iconName} size={42} color="#fff" />
        </span>
        <div style={{ position: "relative", fontFamily: "var(--font-display)", fontWeight: 700, fontSize: 26, lineHeight: 1.15, color: "#fff" }}>
          {gname(lvl)}
        </div>
        <div style={{ position: "relative", fontFamily: "var(--font-mono)", fontWeight: 700, fontSize: 12, letterSpacing: ".08em",
          textTransform: "uppercase", color: "rgba(255,255,255,.82)", marginTop: 7 }}>
          Level {idx} · {tierName}
        </div>
        <div style={{ position: "relative", fontSize: 14.5, lineHeight: 1.5, color: "rgba(255,255,255,.94)", marginTop: 18 }}>
          {CONGRATS}
        </div>
        <div style={{ marginTop: 24 }}>
          {/* v34 — biele (ghost) tlačidlo, nie primary: na farbe tieru je brand výplň nečitateľná
              (rovnaký prístup ako Šťuchnúť/⋮ vo verejnom profile) */}
          <Button variant="ghost" block onClick={onClose}>Super, pokračujem!</Button>
        </div>
      </div>
    </Modal>
  );
  /* token-exempt-end */
}
